module.exports = require("graphql-ws");